import { Component, Inject, OnInit } from '@angular/core';
import { GenericAuthService, GENERIC_AUTH_SERVICE_TOKEN } from '@nk/auth-lib';

@Component({
  selector: 'nk-force-logout',
  templateUrl: './force-logout.component.html',
  styleUrls: ['./force-logout.component.scss'],
  standalone: false,
})
export class ForceLogoutComponent implements OnInit {
  constructor(@Inject(GENERIC_AUTH_SERVICE_TOKEN) private _authService: GenericAuthService) {}

  public ngOnInit(): void {
    this._authService.logout(null, null, false, true, true);
  }
}
